// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.impr-delay-list[data-v-e54e79f0] {\n  padding: 0 !important;\n}\n.impr-delay-active[data-v-e54e79f0] {\n  font-weight: 800;\n  background: #F2C037\n}\n", ""]);
// Exports
module.exports = exports;
